let rounds = [];
    let myChart = null;

    const AVGS = { 'd4': 2.5, 'd6': 3.5, 'd8': 4.5, 'd10': 5.5, 'd12': 6.5 };
    
    /* 2024 GWF Rules: Treat a roll of 1 or 2 as a 3.
       d4: (3+3+3+4)/4 = 3.25
       d6: (3+3+3+4+5+6)/6 = 4.0
       d8: (3*3 + 4+5+6+7+8)/8 = 39/8 = 4.875
       d10: (3*3 + 4..10)/10 = 58/10 = 5.8
       d12: (3*3 + 4..12)/12 = 81/12 = 6.75
    */
    const AVGS_GWF = { 'd4': 3.25, 'd6': 4.0, 'd8': 4.875, 'd10': 5.8, 'd12': 6.75 };
    
    const D_ORDER = ['d4','d6','d8','d10','d12'];
    const BOUNDS = { ac: { min: 0, max: 50 }, toHit: { min: -10, max: 50 }, mod: { min: -10, max: 100 } };
    function clamp(v,min,max){return Math.min(Math.max(v,min),max);}

    function init() {
        rounds = [{
            attacks:[{
                toHit:8,
                dice:['d8'],
                flat:5,
                adv:false,
                superAdv:false,
                bless:false,
                graze:false,
                gwf:false
            }]
        }];
        document.getElementById('target-ac').value = 15;
        document.getElementById('crit-range').value = 20;
        startChart();
        render();
        calc();
    }

    function resetToDefaults() { if(confirm("Reset all combat data to defaults?")) init(); }

    function effectiveRoundConfig(index) {
        const lastIdx = rounds.length - 1;
        const baseIndex = index < rounds.length ? index : lastIdx;
        return rounds[baseIndex];
    }

    function calc() {
        const ac = clamp(parseInt(document.getElementById('target-ac').value)||15, BOUNDS.ac.min, BOUNDS.ac.max);
        const critMin = parseInt(document.getElementById('crit-range').value) || 20;
        let total = 0; 
        let chartData = [0];
        let html = '<div class="round-columns">';

        let effConfigs = [];
        for (let r = 0; r < 4; r++) {
            effConfigs[r] = JSON.parse(JSON.stringify(effectiveRoundConfig(r)));
        }

        for(let r=0; r<4; r++) {
            const rnd = effConfigs[r];
            let rDmg = 0;
            let isDuplicate = false;
            if (r > 0 && JSON.stringify(effConfigs[r]) === JSON.stringify(effConfigs[r-1])) {
                isDuplicate = true;
            }

            html += `<div class="round-col">`;
            html += `<div class="round-col-header">Round ${r+1}${isDuplicate ? ` (same as R${r})` : ''}</div>`;

            if (!isDuplicate) {
                rnd.attacks.forEach((atk, i) => {
                    let dAvg = atk.dice.reduce((sum,d) => sum + (atk.gwf ? AVGS_GWF[d] : AVGS[d]), 0);
                    let totalAvg = dAvg + atk.flat;

                    let bonus = atk.toHit + (atk.bless ? 2.5 : 0);

                    // Chance to hit (including crit range)
                    let pSingle = clamp((21 - (ac - bonus)) / 20, 0.05, 0.95);
                    
                    // Chance to Crit specifically
                    let critBase = (21 - critMin) / 20;
                    critBase = clamp(critBase, 0, 1);

                    let p, crit;
                    if (atk.superAdv) {
                        p = 1 - Math.pow(1-pSingle, 3);
                        crit = 1 - Math.pow(1-critBase, 3);
                    } else if (atk.adv) {
                        p = 1 - Math.pow(1-pSingle, 2);
                        crit = 1 - Math.pow(1-critBase, 2);
                    } else {
                        p = pSingle;
                        crit = critBase;
                    }

                    // p includes the crit chance within it.
                    // pMiss is simply 1 - Total Hit Chance.
                    let pMiss = 1 - p;
                    let grazeFlat = atk.graze ? atk.flat : 0;

                    /* DPR Formula: 
                       (HitChance * NormalDamage) + (CritChance * DiceDamage) + (MissChance * GrazeDamage)
                       Note: "NormalDamage" includes Dice+Mod. 
                       "CritChance * DiceDamage" adds the *extra* dice from the crit.
                    */
                    let eVal = (p * totalAvg) + (crit * dAvg) + (pMiss * grazeFlat);
                    rDmg += eVal;

                    html += `<div style="margin-bottom:8px; padding-bottom:5px; border-bottom:1px dashed #444;">
                        <div style="font-weight:bold;">#${i+1}: +${atk.toHit} vs AC ${ac}</div>
                        <div style="font-size:0.9em;">
                            <span class="c-blue">${(p*100).toFixed(0)}%</span> <span class="op">×</span> 
                            <span class="c-orange">${totalAvg.toFixed(2)}</span> <span class="op">+</span> 
                            <span class="c-purple">${(crit*100).toFixed(1)}%</span> <span class="op">×</span> 
                            <span class="c-grey">${dAvg.toFixed(2)}</span> <span class="op">+</span>
                            <span class="c-grey">${(pMiss*100).toFixed(0)}%</span> <span class="op">×</span>
                            <span class="c-orange">${grazeFlat.toFixed(2)}</span>
                            <span class="op">=</span> 
                            <span class="c-green">${eVal.toFixed(2)}</span>
                        </div>
                    </div>`;
                });
            } else {
                rnd.attacks.forEach((atk) => {
                    let dAvg = atk.dice.reduce((sum,d) => sum + (atk.gwf ? AVGS_GWF[d] : AVGS[d]), 0);
                    let totalAvg = dAvg + atk.flat;
                    let bonus = atk.toHit + (atk.bless ? 2.5 : 0);

                    let pSingle = clamp((21 - (ac - bonus)) / 20, 0.05, 0.95);
                    let critBase = (21 - critMin) / 20;
                    critBase = clamp(critBase, 0, 1);

                    let p, crit;
                    if (atk.superAdv) {
                        p = 1 - Math.pow(1-pSingle, 3);
                        crit = 1 - Math.pow(1-critBase, 3);
                    } else if (atk.adv) {
                        p = 1 - Math.pow(1-pSingle, 2);
                        crit = 1 - Math.pow(1-critBase, 2);
                    } else {
                        p = pSingle;
                        crit = critBase;
                    }

                    let pMiss = 1 - p;
                    let grazeFlat = atk.graze ? atk.flat : 0;

                    let eVal = (p * totalAvg) + (crit * dAvg) + (pMiss * grazeFlat);
                    rDmg += eVal;
                });
                html += `<div style="font-size:0.85em; color:#9ca3af; margin-bottom:4px;">Same as Round ${r}.</div>`;
            }

            total += rDmg; 
            chartData.push(total);
            html += `<div class="round-sum">Round Total: ${rDmg.toFixed(2)}</div>`;
            html += `</div>`;
        }

        html += '</div>';
        document.getElementById('log-content').innerHTML = html;
        document.getElementById('grand-total-bar').innerText = "Total: " + total.toFixed(1);
        document.getElementById('total-dmg').innerText = total.toFixed(0);
        document.getElementById('dpr').innerText = (total/4).toFixed(1);
        if(myChart) { myChart.data.datasets[0].data = chartData; myChart.update(); }
    }

    function render() {
        const c = document.getElementById('rounds-container');
        c.innerHTML = '';
        rounds.forEach((rnd, rI) => {
            let h = `<div class="round-card">
                <div class="round-top">
                    <div class="round-dice-row">
                        <span class="dice-label">Drag Dice:</span>
                        <div class="dice-row">
                            <div class="die-source d4" draggable="true" ondragstart="drag(event)" data-type="d4" data-tip="d4 damage die">d4</div>
                            <div class="die-source d6" draggable="true" ondragstart="drag(event)" data-type="d6" data-tip="d6 damage die">d6</div>
                            <div class="die-source d8" draggable="true" ondragstart="drag(event)" data-type="d8" data-tip="d8 damage die">d8</div>
                            <div class="die-source d10" draggable="true" ondragstart="drag(event)" data-type="d10" data-tip="d10 damage die">d10</div>
                            <div class="die-source d12" draggable="true" ondragstart="drag(event)" data-type="d12" data-tip="d12 damage die">d12</div>
                        </div>
                    </div>
                    
                    <div class="round-title">Round ${rI+1}</div>
                    
                    <div>`;

            if (rI === 0) {
                h += `
                        <div class="global-group">
                            <div class="global-group-title">Global Toggles</div>
                            <div class="global-btn-row">
                                <button class="btn-glb btn-glb-adv" onclick="toggleAll('adv')" data-tip="Toggle Advantage (Green) for ALL attacks.">Adv</button>
                                <button class="btn-glb btn-glb-super" onclick="toggleAll('superAdv')" data-tip="Toggle Super Advantage (Teal) for ALL attacks.">Sup</button>
                                <button class="btn-glb btn-glb-bless" onclick="toggleAll('bless')" data-tip="Toggle Bless (Orange) for ALL attacks.">Bless</button>
                                <button class="btn-glb btn-glb-graze" onclick="toggleAll('graze')" data-tip="Toggle Graze (Purple) for ALL attacks.">Graze</button>
                                <button class="btn-glb btn-glb-gwf" onclick="toggleAll('gwf')" data-tip="Toggle GWF (Grey) for ALL attacks.">GWF</button>
                            </div>
                        </div>`;
            } else {
                 h += `<button class="btn-txt-red" onclick="delRnd(${rI})" data-tip="Remove this round.">Remove Round</button>`;
            }

            h += `</div></div>`;

            rnd.attacks.forEach((atk, aI) => {
                let dHtml = '';
                atk.dice.forEach((d,dI) => { 
                    dHtml += `<div class="mini-die ${d}" onclick="delDie(${rI},${aI},${dI})" onwheel="scrollDie(event,${rI},${aI},${dI})" data-tip="Click to remove.\nScroll to change type.">${d}</div>`; 
                });
                
                h += `<div class="attack-row" ondrop="drop(event,${rI},${aI})" ondragover="allow(event)" data-tip="Configure Attack #${aI+1}">
                    <div style="display:flex; flex-direction:column; align-items:center;">
                        <span style="font-size:0.6em; font-weight:bold; color:#9ca3af;">HIT</span>
                        <input type="number" class="std-input" value="${atk.toHit}" oninput="setV(${rI},${aI},'toHit',this.value)" onwheel="scrollVal(event,this,${rI},${aI},'toHit')">
                    </div>
                    <button class="btn-toggle adv ${atk.adv?'active':''}" onclick="tog(${rI},${aI},'adv')" data-tip="Advantage">Advantage</button>
                    <button class="btn-toggle superadv ${atk.superAdv?'active':''}" onclick="tog(${rI},${aI},'superAdv')" data-tip="Super Advantage (3d20)">Super Adv</button>
                    <button class="btn-toggle bless ${atk.bless?'active':''}" onclick="tog(${rI},${aI},'bless')" data-tip="Bless (+2.5 to hit)">Bless</button>
                    <div class="dice-tray" data-tip="Drag dice here.">${dHtml || '<span style="color:#6b7280; font-size:0.7em;">Drop Dice Here</span>'}</div>
                    <div style="display:flex; flex-direction:column; align-items:stretch; gap:4px;">
                        <button class="btn-flag flag-graze ${atk.graze?'active':''}" onclick="tog(${rI},${aI},'graze')" data-tip="Graze: Deal MOD damage on miss.">Graze</button>
                        <button class="btn-flag flag-gwf ${atk.gwf?'active':''}" onclick="tog(${rI},${aI},'gwf')" data-tip="GWF: Treat damage rolls of 1 or 2 as 3.">GWF</button>
                    </div>
                    <div style="display:flex; flex-direction:column; align-items:center;">
                        <span style="font-size:0.6em; font-weight:bold; color:#9ca3af;">MOD</span>
                        <input type="number" class="std-input" value="${atk.flat}" oninput="setV(${rI},${aI},'flat',this.value)" onwheel="scrollVal(event,this,${rI},${aI},'flat')">
                    </div>
                    <button class="btn-action btn-copy" onclick="dup(${rI},${aI})" data-tip="Duplicate this attack">Duplicate Attack</button>
                    <button class="btn-action btn-del" onclick="delAtk(${rI},${aI})" data-tip="Delete this attack">Delete Attack</button>
                </div>`;
            });
            h += `</div>`;
            c.innerHTML += h;
        });
        const f = document.getElementById('footer-actions');
        if (rounds.length < 4) f.innerHTML = `<button class="btn-add-round" onclick="addRound()" data-tip="Add a new round configuration (up to 4).">+ Add New Round Config</button>`;
        else f.innerHTML = `<div style="text-align:center; color:#95a5a6; font-weight:bold; padding:15px;">Max Rounds (4) Configured</div>`;
    }

    function setV(r,a,k,v) { 
        let val = parseInt(v)||0; 
        if(k==='toHit') val=clamp(val,BOUNDS.toHit.min,BOUNDS.toHit.max);
        if(k==='flat') val=clamp(val,BOUNDS.mod.min,BOUNDS.mod.max);
        rounds[r].attacks[a][k]=val; calc(); 
    }
    function scrollVal(e,el,r,a,k) { e.preventDefault(); let v=parseInt(el.value)||0; v+=(e.deltaY<0?1:-1); el.value=v; setV(r,a,k,v); }
    function scrollDie(e,r,a,d) { e.preventDefault(); e.stopPropagation(); let idx=D_ORDER.indexOf(rounds[r].attacks[a].dice[d]); idx=clamp(idx+(e.deltaY<0?1:-1),0,D_ORDER.length-1); rounds[r].attacks[a].dice[d]=D_ORDER[idx]; render(); calc(); }
    function tog(r,a,k) { 
        if (k === 'superAdv' && !rounds[r].attacks[a][k]) {
            rounds[r].attacks[a].adv = false;
        }
        if (k === 'adv' && !rounds[r].attacks[a][k]) {
            rounds[r].attacks[a].superAdv = false;
        }
        rounds[r].attacks[a][k]=!rounds[r].attacks[a][k]; 
        render(); 
        calc(); 
    }
    function dup(r,a) { rounds[r].attacks.splice(a+1,0, JSON.parse(JSON.stringify(rounds[r].attacks[a]))); render(); calc(); }
    function delAtk(r,a) { 
        rounds[r].attacks.splice(a,1); 
        if(rounds[r].attacks.length===0) 
            rounds[r].attacks.push({toHit:8, dice:['d8'], flat:5, adv:false, superAdv:false, bless:false, graze:false, gwf:false}); 
        render(); calc(); 
    }
    function delDie(r,a,d) { rounds[r].attacks[a].dice.splice(d,1); render(); calc(); }
    function addRound() { if(rounds.length>=4)return; rounds.push(JSON.parse(JSON.stringify(rounds[rounds.length-1]))); render(); calc(); }
    function delRnd(r) { rounds.splice(r,1); render(); calc(); }
    function drag(e){e.dataTransfer.setData("text",e.target.dataset.type);}
    function allow(e){e.preventDefault();}
    function drop(e,r,a){ e.preventDefault(); const t=e.dataTransfer.getData("text"); if(AVGS[t]){rounds[r].attacks[a].dice.push(t); render(); calc();} }

    function toggleAll(type) {
        let anyOff = false;
        rounds.forEach(r => r.attacks.forEach(a => { if(!a[type]) anyOff = true; }));
        const newState = anyOff ? true : false;

        rounds.forEach(r => r.attacks.forEach(a => { 
            if (type === 'adv' && newState) {
                a.superAdv = false;
            }
            if (type === 'superAdv' && newState) {
                a.adv = false;
            }
            a[type] = newState; 
        }));
        render();
        calc();
    }

    function startChart() {
        const ctx=document.getElementById('dmgChart').getContext('2d');
        if(myChart) myChart.destroy();
        myChart = new Chart(ctx, { 
            type:'line', 
            data:{
                labels:['Start','R1','R2','R3','R4'], 
                datasets:[{
                    data:[0], 
                    borderColor:'#2c3e50', 
                    backgroundColor:'rgba(52, 152, 219, 0.2)', 
                    fill:true, 
                    tension:0.3
                }]
            }, 
            options:{
                responsive:true, 
                maintainAspectRatio:false, 
                plugins:{legend:{display:false}}, 
                scales:{y:{beginAtZero:true}}
            }
        });
    }

    function toggleTheme() {
        const root = document.querySelector('.dpr-simulator');
        if (!root) return;
        root.classList.toggle('light');
        const btn = document.getElementById('theme-toggle');
        if (root.classList.contains('light')) {
            btn.textContent = '☀';
            btn.setAttribute('data-tip', 'Switch back to dark layout.');
        } else {
            btn.textContent = '☾';
            btn.setAttribute('data-tip', 'Switch to light layout.');
        }
    }

    const tt = document.getElementById('tt');
    document.addEventListener('mousemove', e => {
        const t = e.target.closest('[data-tip]');
        if(t) { 
            tt.innerText = t.dataset.tip.replace(/\\n/g, '\n'); 
            tt.style.display='block';
            let left = e.clientX + 12; 
            if(left+260 > window.innerWidth) left = e.clientX-270;
            tt.style.left=left+'px'; 
            tt.style.top=(e.clientY+12)+'px';
        } else tt.style.display='none';
    });
    document.addEventListener('wheel', () => { tt.style.display='none'; });

    document.getElementById('target-ac').addEventListener('wheel', e => { 
        e.preventDefault(); 
        let v=parseInt(e.target.value)||15; 
        v+=(e.deltaY<0?1:-1); 
        e.target.value=clamp(v,BOUNDS.ac.min,BOUNDS.ac.max); 
        calc(); 
    });

    init();
